export const Draft = -1
export const New = 0
export const WithOffers = 1
export const Deal = 2
export const Rejected = 3
export const AutoRejected = 4
